export enum GAEventType {
  INIT = "init",
  PAYMENT = "payment",
  REDIRECT = "redirect",
}
